import React, { createContext, useContext, useState, useRef } from 'react';

const GlobalChatContext = createContext();

export const useGlobalChat = () => {
  const context = useContext(GlobalChatContext);
  if (!context) {
    throw new Error('useGlobalChat must be used within a GlobalChatProvider');
  }
  return context;
};

export const GlobalChatProvider = ({ children }) => {
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [chatbotWidth, setChatbotWidth] = useState(() => {
    const saved = localStorage.getItem('global-chat-width');
    return saved ? parseInt(saved, 10) : 0;
  });
  
  // Refs for chat components
  const chatBtnRef = useRef(null);
  const chatSidebarRef = useRef(null);
  
  // Ref for SQL-specific props provider
  const sqlPropsRef = useRef(null);

  const showChatbot = (width) => {
    const finalWidth = width || (window.innerWidth >= 768 ? window.innerWidth * 0.35 : window.innerWidth - 300);
    setChatbotWidth(finalWidth);
    localStorage.setItem('global-chat-width', finalWidth.toString());
    setIsChatbotVisible(true);
  };

  const hideChatbot = () => {
    setChatbotWidth(0);
    localStorage.setItem('global-chat-width', '0');
    setIsChatbotVisible(false);
  };

  const showError = (errorData) => {
    if (chatBtnRef.current) {
      chatBtnRef.current.showError(errorData);
    }
    if (chatSidebarRef.current && !isChatbotVisible) {
      // Auto-open chatbot if there's an error and it's not visible
      showChatbot();
      setTimeout(() => {
        if (chatSidebarRef.current) {
          chatSidebarRef.current.showError(errorData);
        }
      }, 100);
    } else if (chatSidebarRef.current) {
      chatSidebarRef.current.showError(errorData);
    }
  };

  const startFix = (errorData) => {
    if (chatBtnRef.current) {
      chatBtnRef.current.showError(errorData);
    }
    if (!isChatbotVisible) {
      // Auto-open chatbot if there's an error and it's not visible
      showChatbot();
      setTimeout(() => {
        if (chatSidebarRef.current) {
          chatSidebarRef.current.startFix(errorData, true);
        }
      }, 200);
    } else if (chatSidebarRef.current) {
      chatSidebarRef.current.startFix(errorData, false);
    }
  };

  const value = {
    isChatbotVisible,
    chatbotWidth,
    showChatbot,
    hideChatbot,
    showError,
    startFix,
    chatBtnRef,
    chatSidebarRef,
    sqlPropsRef,
    setChatbotWidth: (width) => {
      setChatbotWidth(width);
      localStorage.setItem('global-chat-width', width.toString());
    }
  };

  return (
    <GlobalChatContext.Provider value={value}>
      {children}
    </GlobalChatContext.Provider>
  );
};